"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTag = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Tag_1 = require("@src/components/elements/Tag/Tag");
const SelectTag = ({ children, label, closable, onClose, loading, }) => {
    const onPreventMouseDown = event => {
        event.preventDefault();
        event.stopPropagation();
    };
    if (loading) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    return ((0, jsx_runtime_1.jsxs)(CustomFilterSelectTag, { onMouseDown: onPreventMouseDown, closable: closable, onClose: onClose, children: [children && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }), !children && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: label })] }));
};
exports.SelectTag = SelectTag;
const CustomFilterSelectTag = (0, styled_components_1.default)(Tag_1.Tag) `
	display: inline-flex;
	line-height: 1.6rem;
	font-size: 0.9rem;
	align-items: center;
	margin-right: 0;

	.ant-tag-close-icon {
		margin-left: 0.75rem;

		& > svg {
			width: 16px;
			height: 16px;
		}
	}
`;
